module.exports = __webpack_public_path__ + "img/regular_lease_process07.ca987192.png";